import * as types from "./mutation-types";

export default {
  [types.SET_PAYER_DATA](state, payload) {
    state.payerData = payload;
  },
  [types.SET_PAYER_VALIDATION_FIELDS](state, payload) {
    state.payerValidationFields = payload;
  },
  [types.SET_DOWNGRADE_DATA](state, payload) {
    state.downgradeData = payload;
  },
};
